import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { handleMultipleDownload } from "../utils/handleMultipleDownload";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { MetaInterface } from "../../../common/interfaces/MetaInterface";
import DownloadIcon from "../../../common/images/download.svg?react";
import { JSX } from "react";

interface Props {
    certificatesData?: {
        data: CertificateInterface[];
        meta?: MetaInterface;
    };
    blobData?: Blob;
}

export const EmployeeInactiveDownloadAllButton = (
    props: Props,
): JSX.Element => {
    const { certificatesData, blobData } = props;

    return (
        <div className={"p-employee-inactive__content__download-all"}>
            <h3>Certificaten ({certificatesData?.meta?.total})</h3>
            {blobData && (
                <Button
                    variant={"primary"}
                    loading={false}
                    onClick={() => handleMultipleDownload(blobData)}
                >
                    <DownloadIcon />
                    Alle certificaten downloaden
                </Button>
            )}
        </div>
    );
};
